import Marionette from 'backbone.marionette'
import template from 'text-loader!templates/agents/resultListLandingPage.html'

var resultListLandingPageView = Marionette.ItemView.extend({
  template: template
});

export default resultListLandingPageView;

